import { createI18n } from 'vue-i18n';

export const i18n = createI18n({
  fallbackLocale: 'en', //always displays English if translation is not available
  messages: {},
  globalInjection: true,
  allowComposition: false,
  silentTranslationWarn: true,
  warnHtmlInMessage: 'off'
});

const argumentschecker =
  (method) =>
  (...args) => {
    if (!args[0]) {
      return null;
    }
    // Check if the translation string contains '@' and escape it if necessary.
    const locale = i18n.global.locale?.value || i18n.global.locale;
    const messages = i18n.global.getLocaleMessage(locale);
    const rawValue = messages[args[0]];
    if (typeof rawValue === 'string' && rawValue.includes('@') && !/\{'@'\}/.test(rawValue)) {
      // To allow @ in translation strings, we need to escape it as {'@'}.
      const escapedValue = rawValue.replace(/@/g, "{'@'}");
      if (escapedValue !== rawValue) {
        i18n.global.mergeLocaleMessage(locale, { [args[0]]: escapedValue });
      }
    }
    return i18n.global[method](...args);
  };

export const $t = argumentschecker('t');

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(i18n);
  // This will use the custom translation logic over default one in vue templates.
  nuxtApp.vueApp.mixin({
    methods: {
      $t: argumentschecker('t')
    }
  });
  return {
    enforce: 'pre', // or 'post'
    provide: {
      i18n: i18n,
      $t: argumentschecker('t')
    }
  };
});
